import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { Footer } from "AppSrc/footer";
import BootstrapSplitPane from "traec-react/utils/bootstrap/splitbs";
import AdminRouter from "./router";

import { PermissionWarning } from "traec/utils/permissions/project";
import { ErrorBoundary } from "storybook-dashboard/errors";

function SideBarLinks({ show }) {
  if (!show) {
    return null;
  }
  return (
    <div className="mt-4">
      <p>
        <Link to="/tenant/admin/basemetric">Base Metrics</Link>
      </p>
      <p>
        <Link to="/tenant/admin/indicator">Base Indicators</Link>
      </p>
      <p>
        <Link to="/tenant/admin/conversion">Conversion Factors</Link>
      </p>
      <p>
        <Link to="/tenant/admin/subtenant">Sub-Tenancies</Link>
      </p>
      <p>
        <Link to="/tenant/admin/version">Version</Link>
      </p>
    </div>
  );
}

function AdminPage() {
  const [showSideBar, setShowSideBar] = useState(true);

  // Get user from Redux state
  const user = useSelector((state) => state.getIn(["auth", "user"]));

  // Return a simple permission denied page
  if (!(user && user.get("is_tenant_superuser"))) {
    return <PermissionWarning />;
  }

  // Render the page and sidebar
  return (
    <>
      <BootstrapSplitPane
        localStorageKey={`explorer-grid-split-admin`}
        allowZero={true}
        pane1ClassName={"page-sidebar"}
        onCollapseHook={() => {
          setShowSideBar(false);
        }}
        onExpandHook={() => {
          setShowSideBar(true);
        }}
        pane1Style={{
          borderRight: "1px solid grey",
          overflowY: "auto",
        }}
        pane2Style={{
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          flexGrow: "1",
        }}
      >
        <div>
          <main aria-label="Sidebar panel content">
            <ErrorBoundary>
              <SideBarLinks show={showSideBar} />
            </ErrorBoundary>
          </main>
        </div>

        <div>
          <main aria-label="Main panel content">
            <ErrorBoundary>
              <AdminRouter />
            </ErrorBoundary>
          </main>
        </div>
      </BootstrapSplitPane>
      {/* <Footer /> */}
    </>
  );
}

export default AdminPage;
